export default __webpack_public_path__ + "static/store-manager-1-cf12902d6175e0826a33a0e3976ccd8e.png";